import { uploadedFileUrl } from '../../../../../utils/constants/links';

export default function ViewScrnShot({ row }) {
  return <img alt="screenShot" src={`${uploadedFileUrl}/${row?.mou_screenshot}`} />;
}
